import { Heading, PageBlock, Stack, Text, textVariants } from '@etg/wings';
import { TripType } from '@eti/schema-types';
import { css } from '@eti/styles';
import { useSearch, useTranslation } from '@eti/providers';
import ProgressiveBackgroundSteps from './ProgressiveBackgroundSteps';
import TextRotator from './TextRotator';

const pageBlockStyles = css`
  align-items: center;
  height: 100%;
  text-align: center;
`;

const tripStyles = css`
  display: flex;
`;

const separatorStyles = css`
  display: inline-block;
  padding-inline: 0.35rem;
`;

const MetaToBrandLoader = () => {
  const { t } = useTranslation();
  const { currentSearchData } = useSearch();
  const { destination, origin, tripType } = currentSearchData ?? {};

  return (
    <PageBlock
      className={pageBlockStyles}
      data-testid="resultPage-metaBrand-progressIndicator"
      withPaddingY
    >
      <Stack align="center" spacing={24}>
        <Heading level={2}>{t('Result.MetaToBrandLoader.Heading')}</Heading>
        <ProgressiveBackgroundSteps />
        <Text className={tripStyles} variant={textVariants._18_EMPHASIZED}>
          {tripType === TripType.MultiStop ? (
            t('SearchTransition.MultipleDestinations')
          ) : (
            <>
              <span>{origin?.city}</span>
              <span className={separatorStyles}>–</span>
              <span>{destination?.city}</span>
            </>
          )}
        </Text>
        <TextRotator />
      </Stack>
    </PageBlock>
  );
};

export default MetaToBrandLoader;
